module.exports = __webpack_public_path__ + "img/ios-badge-sm.8ed8ad31.png";